var _path, _path2, _path3, _mask, _g, _path4, _path5, _path6, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 80,
    viewBox: "0 0 235 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7387 17.1433L23.727 36.4185L9.72388 17.1433H0V61.9746H8.44244V29.3669L22.7064 48.9033H24.3691L38.9521 29.4409V61.9746H47.393V17.1433H37.7387Z",
    fill: "#0255A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3815 17.1433L69.1033 61.9746H60.5244L66.4168 48.2484L53.7974 17.1433H62.8929L67.694 30.7968L70.7055 39.7159L73.974 30.9916L79.7358 17.1433H88.3815Z",
    fill: "#0255A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.792 25.4495V27.2004V41.528H153.412C157.007 41.528 159.367 39.7212 160.556 37.3284C161.612 35.2014 161.665 32.6221 160.826 30.3982C156.681 28.7941 152.762 27.1358 149.03 25.4495H140.792Z",
    fill: "#0255A3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 2,
    width: 159,
    height: 78
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9248 2.44165H234.409V80.0001H76.9248V2.44165Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.469 62.7206H116.127V47.7188V32.67V17.3436H124.469V62.7206ZM217.198 50.4803C214.777 56.3045 210.151 61.0387 203.039 62.8689C201.016 63.3919 198.861 63.7562 196.438 63.7562C193.84 63.7562 191.56 63.3405 189.423 62.7676C179.235 60.0075 174.149 51.3367 173.622 41.9842C173.592 41.4407 173.497 40.9046 173.497 40.3538C173.497 38.5808 173.682 36.8108 174.018 35.076C172.542 34.6001 171.123 34.1051 169.692 33.616C169.649 35.8942 169.194 38.1666 168.274 40.2436C165.997 45.3774 161.086 49.361 153.412 49.361H140.792V62.7206H132.383V21.2376V17.3436C132.544 17.3436 132.7 17.3406 132.861 17.3406C123.325 12.0335 115.739 6.83805 110.011 2.44165C102.023 6.38122 96.4682 14.6981 96.4682 24.29V55.711C96.4682 56.0048 96.5 56.2957 96.513 56.5894L96.4177 56.5116C96.4177 56.5116 98.0045 80.0006 76.9248 80.0006H120.346H125.182H210.532C223.667 80.0006 234.41 69.0691 234.41 55.711V47.0284C229.041 46.5525 223.813 45.9723 218.774 45.2584C218.416 47.0519 217.891 48.8058 217.198 50.4803Z",
    fill: "#0255A3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.783 40.4922C181.813 41.8112 182.018 43.1347 182.299 44.4435C183.628 50.5012 187.786 55.9111 196.437 55.9111C202.506 55.9111 206.328 53.1981 208.551 49.5053C209.565 47.822 210.215 45.933 210.606 43.994C200.322 42.2343 190.777 40.0089 181.946 37.4824C181.813 38.4886 181.757 39.4992 181.783 40.4922Z",
    fill: "#0255A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.437 24.2158C187.287 24.2158 182.827 30.7436 181.946 37.4829C190.777 40.0094 200.322 42.2333 210.607 43.993C210.845 42.8091 211.008 41.6134 211.028 40.4148C211.151 32.7765 206.949 24.2158 196.437 24.2158Z",
    fill: "#0255A3",
    fillOpacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.412 25.4495H149.03C152.762 27.1358 156.681 28.7941 160.827 30.3982C159.79 27.6484 157.353 25.4495 153.412 25.4495Z",
    fill: "#0255A3",
    fillOpacity: 0.7
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 110,
    y: 0,
    width: 125,
    height: 48
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.01 0H234.409V47.0295H110.01V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.533 0H120.346C116.644 0 113.145 0.894555 110.01 2.4413C115.74 6.83769 123.326 12.0332 132.862 17.3403C139.712 17.3373 146.562 17.2801 153.411 17.2801C164.449 17.2801 169.843 25.497 169.693 33.6156C171.123 34.1047 172.542 34.5998 174.019 35.0757C175.928 25.1327 183.309 16.4354 196.437 16.4354C211.792 16.4354 219.437 28.4275 219.309 40.2902C219.289 41.9648 219.102 43.6261 218.775 45.2595C223.812 45.9719 229.041 46.5521 234.409 47.0295V24.2896C234.409 10.93 223.668 0 210.533 0Z",
    fill: "#0255A3",
    fillOpacity: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.fca18c6aa0dd10d21cd5dcbf587dc7e3.svg";
export { ForwardRef as ReactComponent };